import React from 'react';
import {toast} from 'react-toastify';

const UNDO_TOAST_ID = 'alerts-center-undo';
// README §6: borrar una regla es reversible 5 s en la UI (y siempre en la base: el borrado es soft).
export const UNDO_MS = 5000;

function UndoToastContent({message, undoLabel, onUndo, closeToast}) {
    return (
        <div className="alc-toast">
            <span className="alc-toast__message">{message}</span>
            <button type="button" className="alc-toast__undo"
                    onClick={() => { onUndo(); if (closeToast) closeToast(); }}>
                {undoLabel}
            </button>
        </div>
    );
}

/**
 * «Regla eliminada.» con «Deshacer» durante 5 segundos, en lugar de un modal de confirmación. Mismo
 * patrón que la galería de prompts (`promptUndoToast.js`): un solo `toastId` —react-toastify DESCARTA
 * en silencio un `toast()` con un id activo— y `updateId` por regla, para que dos bajas seguidas
 * actualicen el aviso y el botón deshaga la ÚLTIMA.
 */
export function showRuleUndoToast({message, undoLabel, onUndo, actionId}) {
    const render = ({closeToast}) => (
        <UndoToastContent message={message} undoLabel={undoLabel} onUndo={onUndo} closeToast={closeToast}/>
    );
    const options = {
        toastId: UNDO_TOAST_ID,
        updateId: String(actionId),
        autoClose: UNDO_MS,
        closeOnClick: false,
        pauseOnHover: true,
    };
    if (toast.isActive(UNDO_TOAST_ID)) {
        toast.update(UNDO_TOAST_ID, {...options, render});
    } else {
        toast(render, options);
    }
}

export function dismissRuleUndoToast() {
    toast.dismiss(UNDO_TOAST_ID);
}
